<template>
  <a class="mr-2" @click="triggerHistory">
    <slot>
      <a variant="default" size="small">
        <span v-if="bulkAction">
          <MIcon name="times" class="text-neutral-light mr-2 ml-1" />
          <span class="ml-1 action-menu-text">
            {{ $tc('reject') }}
          </span>
        </span>
        <span v-else>
          <MButton
            shape="circle"
            class="mr-1"
            variant="error"
            :disabled="item.status === 'rejected_pending'"
          >
            <MIcon name="times" />
          </MButton>
        </span>
      </a>
    </slot>
    <FlotoDrawerForm
      :open="showCreateDrawer"
      :width="'65%'"
      @cancel="hideDrawer"
      @submit="handleCreateAndRelate"
    >
      <template v-slot:header>
        {{ $t('create') }} {{ $tc(selectedRelationType) }}
      </template>
      <component
        :is="formComponent"
        v-if="selectedRelationType && canShowForm"
        :value="creatingResource"
        :module-name="selectedRelationType"
        :processing="processing"
        :with-submit="false"
        :default-selected-assets="[]"
        @templateSelected="handleTemplateSelected"
        @change="handleChangeCreatingResource"
        @selection-change="setSelectedItems"
      />
      <FlotoLoadError
        v-else
        size="small"
        :use-margin-top="false"
        authorization-error
      />
      <template v-slot:actions="{ hide, submit }">
        <MButton
          :disabled="!canShowForm"
          outline
          class="mr-2"
          :loading="processing"
          @click="submit"
        >
          {{ $t('create') }}
        </MButton>
        <MButton variant="default" @click="hide">
          {{ $t('cancel') }}
        </MButton>
      </template>
    </FlotoDrawerForm>
  </a>
</template>
<script>
import TicketForm from '@modules/ticket/components/ticket-form'
import { VarianceRejectApi } from '../../../asset-api'
import { LicenseComputed } from '@state/modules/license'

export default {
  name: 'VarianceRejectionDrawer',
  props: {
    item: {
      type: [Object, Array],
      default: undefined,
    },
    variance: {
      type: Array,
      default: undefined,
    },
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    bulkAction: { type: Boolean, defauult: false },
    selectedItemsId: { type: Array, default: undefined },
  },
  data() {
    return {
      processing: false,
      selectedRelationType: this.$constants.CHANGE,
      moduleName: this.$constants.CHANGE,
      showCreateDrawer: false,
      creatingResource: {},
      selectedItems: [],
    }
  },
  computed: {
    ...LicenseComputed,
    canShowForm() {
      if (this.availableModulesInLicense.indexOf(this.$constants.CHANGE) >= 0) {
        return true
      }
      return false
    },

    formComponent() {
      if ([this.$constants.CHANGE].indexOf(this.selectedRelationType) >= 0) {
        return TicketForm
      }
      return 'template'
    },
  },
  methods: {
    setSelectedItems(items) {
      this.selectedItems = items
    },
    handleTemplateSelected(template) {
      if (!Object.keys(template).length) {
        this.creatingResource = {}
      }
    },
    handleChangeCreatingResource(data) {
      this.creatingResource = {
        ...this.creatingResource,
        ...data,
      }
    },
    handleCreateAndRelate() {
      if (this.processing) {
        return
      }
      this.processing = true
      const moduleName = this.selectedRelationType
      VarianceRejectApi(
        this.selectedItemsId ? this.selectedItemsId : [this.item.id],
        this.resourceId,
        {
          ...this.creatingResource,
          moduleName,
        }
      )
        .then((data) => {
          this.$emit('refresh')
          this.hideDrawer()
          this.creatingResource = {}
        })
        .finally(() => {
          setTimeout(() => {
            this.processing = false
          }, 300)
        })
    },
    hideDrawer() {
      this.showCreateDrawer = false
      this.creatingResource = {}
      this.selectedItems = []
    },
    triggerHistory() {
      this.$emit('trigger')
      setTimeout(() => {
        this.showCreateDrawer = true
      }, 400)
    },
  },
}
</script>
